import React from 'react'
import classNames from 'classnames'
import './Stripe.css'

export default ({ className }) => (
  <div className={classNames('color-stripe', className)}>
    <StripeBar color="#00a898" />
    <StripeBar color="#ffc00e" />
    <StripeBar color="#ef4c30" />
  </div>
)

export const StripeBar = ({ color }) => (
  <div className="color-stripe-bar" style={{ backgroundColor: color }} />
)
